const FULL_TURN = 360;
const HALF_TURN = 180;
const UPRIGHT_THRESHOLD = 90;

// Panel rotation (and an item's own instance rotation) can combine to carry an SVG group past
// vertical, flipping its wording upside-down (e.g. a back panel alone is rotate(-180)). Fold the
// cumulative angle back into the readable half-circle -- callers apply this only to rotationally
// symmetric geometry, so a 180deg correction affects text legibility without moving anything.
export const getUprightTextCorrection = (cumulativeAngleDeg: number): number => {
	const normalized = ((cumulativeAngleDeg % FULL_TURN) + FULL_TURN) % FULL_TURN;
	return normalized > UPRIGHT_THRESHOLD && normalized < FULL_TURN - UPRIGHT_THRESHOLD ? HALF_TURN : 0;
};
